import React, { useState, useEffect } from "react";
import "./NikunjDiamondFilter.css";
import CartItems from "../components/CartItems";
import { BsPaypal } from "react-icons/bs";
import { FaGooglePay } from "react-icons/fa";
import { FiPhoneCall } from "react-icons/fi";
import { HiChatAlt2 } from "react-icons/hi";
import { MdEmail } from "react-icons/md";

const NikunjDiamondFilter = () => {
  // const url = 'https://jsonplaceholder.typicode.com/users'
  // const url =
  //   "http://ec2-34-197-250-249.compute-1.amazonaws.com/api/product_read";
  // const [data, setData] = useState([]);
  // const [loading, setLoading] = useState(true)
  // const [error, setError] = useState(false)

  // const fetchData = async () => {
  //   const res = await axios.get(url);
  //   setData(res.data.data);
  //   console.log(res.data.data);
  // };

  // useEffect(() => {
  //   fetchData();
  // }, []);

  const handleClick = (e) => {
    e.preventDefault();
    alert("Order Has Been Placed");
  };

  return (
    <>
      <div className="container">
        <div className="row d-flex">
          <h1 className="my-5 fw-bold">Your Cart</h1>
          <div className="col-8 d-flex">
            <div className="me-2">
              <CartItems />
              <CartItems />
              {/* <CartItems /> */}

              <button className="btn p-3 fw-bold btn-outline-dark">
                CONTINUE SHOPPING
              </button>
              {/* <CartItems /> */}
            </div>
            {/* <div className="col-4 text-center border border-secondary rounded">
              <p>Hello</p>
            </div> */}
            {/* <table className="nikunj-table w-100">
              <thead className="nikunj-table">
                <tr className="nikunj-table">
                  <th className="nikunj-table">&nbsp;</th>
                  <th className="nikunj-table">Shape</th>
                  <th className="nikunj-table">Carat</th>
                  <th className="nikunj-table">Price</th>
                  <th className="nikunj-table">Cut</th>
                  <th className="nikunj-table">Color</th>
                  <th className="nikunj-table">&nbsp;</th>
                </tr>
              </thead>
              <tbody className="nikunj-table">
                {data.map((product) => (
                  <tr className="nikunj-table" key={product.product_id}>
                    <td className="nikunj-table">
                      <img
                        src={product.product_image}
                        style={{ width: "100px", height: "100px" }}
                      ></img>
                    </td>
                    <td className="nikunj-table">{product.shape_name}</td>
                    <td className="nikunj-table">{product.carat}</td>
                    <td className="nikunj-table">{<FormatPrice price={product.product_price} />}</td>
                    <td className="nikunj-table">{product.cut_name}</td>
                    <td className="nikunj-table">{product.color_name}</td>
                    <td className="nikunj-table"><NavLink to={`/design-your-own-jewellery/${product.product_id}`} className="btn__link ms-0">Details</NavLink></td>
                  </tr>
                ))}
              </tbody>
            </table> */}
          </div>
          <div className="col-4 border border-secondary rounded px-2">
            <h5 className="mt-3 mb-4 text-center fw-bold">Order Summery</h5>
            <p className="fw-strong mt-3">Coupan Code</p>
            <div class="input-group my-3">
              <input
                type="text"
                class="form-control"
                placeholder="Enter Coupan Code"
              />
              <button
                class="btn btn-secondary"
                type="button"
                id="button-addon2"
              >
                Apply
              </button>
            </div>
            <hr className="my-4" />
            {/* <p className="fw-strong">Merchandise Subtotal: <span className="fw-bold text-end">$100.00</span></p> */}
            <table className="table my-3 py-3">
              <tbody>
                <tr>
                  <td className="text-start">Merchandise Subtotal:</td>
                  <td className="text-end">$10,000.00</td>
                </tr>
                <tr>
                  <td className="text-start fw-bold">Order Total:</td>
                  <td className="text-end fw-bold">$10,000.00</td>
                </tr>
              </tbody>
            </table>
            <button
              className="btn btn-secondary w-100 p-3 my-2"
              onClick={handleClick}
            >
              SECURE CHECKOUT
            </button>

            <hr class="hr-text" data-content="EXPRESS CHECKOUT" />

            <div className="d-flex flex-column text-center my-4">
              <a href="#" className="link-dark">
                <BsPaypal /> Paypal
              </a>
              <br />
              <a href="#" className="link-dark">
                <FaGooglePay /> Google Pay
              </a>
            </div>

            <div className="contact mt-5 d-flex justify-content-evenly align-items-center">
              <a href="#" className="link-dark">
                <FiPhoneCall /> 8454988407
              </a>
              <a href="#" className="link-dark">
                <HiChatAlt2 /> Live Chat
              </a>
              <a href="#" className="link-dark">
                <MdEmail /> Email Us
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NikunjDiamondFilter;
